import {Card, CardContent, CardHeader, CardTitle,} from "@/components/ui/card";
import {Calendar, Clock, MapPin} from "lucide-react";
import {useSignals} from "@preact/signals-react/runtime";
import {buyTicketCurrentStep, BuyTicketsSteps,} from "@/app/events/[id]/store/buy-tickets.store";
import {eventInSingleEventPage} from "@/app/events/store/single-page.store";
import {extractUtcOffset, formatedDateTimeOffsetUtc} from "@/lib/date-time-utils";
import {SelectTickets} from "@/app/events/[id]/components/SelectTickets";
import {PaymentDetails} from "@/app/events/[id]/components/PaymentDetails";
import {OrderSummary} from "@/app/events/[id]/components/OrderSummary";
import {CheckoutLoginForm} from "@/app/events/[id]/components/CheckoutLoginForm";

const DynamicStepStepMap = {
  [BuyTicketsSteps.SelectTicket]: SelectTickets,
  [BuyTicketsSteps.PaymentDetails]: PaymentDetails,
  [BuyTicketsSteps.LoginForm]: CheckoutLoginForm,
};

export const TicketSelector = () => {
  useSignals();
  const event = eventInSingleEventPage.value;
  console.log('event', event);
  const DynamicStep = DynamicStepStepMap[buyTicketCurrentStep.value] ?? null;

  return (
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-3 h-[95vh] md:h-auto overflow-auto bg-stone-neutral-0">
          <div className="md:col-span-2">
            <Card
                className="rounded-none shadow-none flex flex-col border-0 md:border-r md:border-gray-300 md:h-[90vh]">
              <CardHeader
                  className="bg-white z-10 border-b border-gray-300 justify-center py-4 sticky md:relative top-0 md:top-auto">
                <CardTitle className="text-2xl font-medium text-midnight-teal text-center">
                  {event?.name}
                </CardTitle>
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 justify-center items-center">
                  <div className="flex text-sm text-muted-foreground mt-2">
                    <MapPin className="w-4 h-4 mr-2"/>
                    <span>{event?.location?.name}</span>
                  </div>
                  <div className="flex text-sm text-muted-foreground mt-1">
                    <Calendar className="w-4 h-4 mr-2"/>
                    <span>{event?.startTimeStamp && event?.location?.timeZone && formatedDateTimeOffsetUtc(event.startTimeStamp, extractUtcOffset(event.location.timeZone), "dddd, MMMM D yyyy")}</span>
                  </div>
                  <div className="flex text-sm text-muted-foreground mt-1">
                    <Clock className="w-4 h-4 mr-2"/>
                    <span>{event?.startTimeStamp && event?.location?.timeZone && formatedDateTimeOffsetUtc(event.startTimeStamp, extractUtcOffset(event.location.timeZone), "h:mm A")}</span>
                  </div>
                </div>
              </CardHeader>
              <DynamicStep/>
            </Card>
          </div>
          <Card className="border-none px-4 md:pl-0 md:pr-4 flex flex-col">
            <CardHeader className="px-0">
              <CardTitle>Order Summary</CardTitle>
            </CardHeader>
            <CardContent className="px-0 grow flex flex-col pb-28 md:pb-4">
              <OrderSummary/>
            </CardContent>
          </Card>
        </div>
      </div>
  );
};
